import React from 'react';
import { Image, View, ImageBackground, StyleSheet, Platform } from 'react-native'
import { Text, Overlay } from 'react-native-elements';

import background from '../../images/background-slot.jpg'
import SlotVendors from '../../libs/slots-vendors'
import sexy_banner from '../../images/sexy-banner.png'
import manual_banner from '../../images/manual-banner.png'
import sexy_disabled from '../../images/sexy-disabled.png'
import sa_banner from '../../images/sa-banner.jpg'
import sa_disabled from '../../images/sa-disabled.png'
import { TouchableOpacity } from 'react-native-gesture-handler';
import { Dimensions } from 'react-native-web';
import OverlayWeb from '../web/Overlay';
import Settings from '../settings'
import TextZ from '../TextZ';
import Page from './page'
import logo from '../../images/main-logo.png'
import moment from 'moment'
import { Tab } from 'react-native-elements/dist/tab/tab';


const noPackage = (pname, pexpire) => {
  switch(pname.toUpperCase()) {
      case '': case null: case 'NONE':
      return true;
  }
  if (!pexpire) {
    throw new Error('No package expire date')
  }

  return moment(pexpire).isBefore(moment())
}

export default class Component extends React.Component {

    state = {
        popup: false,
        activeTab: 0,
    }

    onClick = (game, room) => {
        this.props.callback(game, room)
    }

    openPopup = (isOpen) => {
      this.setState({ popup: isOpen })
    }

    onTab = (tab) => {
      this.setState({ activeTab: tab })
    }

    render() {

        // const direction = Dimensions.get('window').width > 472 ? 'row' : 'column';
        const Overlayer = Platform.OS === 'web' ? OverlayWeb : Overlay;

        const vip = !noPackage(this.props.subscription, this.props.subscription_expire)

        return <Page
              onSetting={() => { this.openPopup( true ) }}
              onToggleRoom={() => { }}
              logo={logo}
              title={`เลือกสูตร`}
              // onClickLogo={() => {}}
              background={background}
          >
          <View style={styles.page}>
            <Tab variant="primary" indicatorStyle={{ backgroundColor: 'red' }} onChange={this.onTab} value={this.state.activeTab}>
              <Tab.Item title="สล็อต" containerStyle={styles.tab}/>
              <Tab.Item title="บาคาร่า" containerStyle={styles.tab}/>
            </Tab>
            <View style={styles.tabContent}>
              <View style={[styles.container, this.state.activeTab === 0 ? null : styles.hide ]}>
                <View style={{
                    flexDirection: 'column',
                    alignItems: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    flexGrow: 1,
                }}>
                  <View style={{
                      flexDirection: 'row',
                      alignItems: 'flex-end',
                      alignContent: 'center',
                      justifyContent: 'center',
                      flexGrow: 1,
                      paddingTop: 20
                  }}>
                      <TextZ h1 style={[styles.title, styles.h1]}>เลือกค่าย สล็อต</TextZ>
                  </View>
                  <View style={{
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                      justifyContent: 'center',
                      maxWidth: '100vw',
                  }}>
                      {SlotVendors.map(v => (
                          <TouchableOpacity onPress={() => this.onClick('slot', v.code)} key={v.code} style={styles.game_block}>
                              <Image source={{ uri: v.img }} resizeMode='contain' style={{ backgroundColor: '#000000', width: 193, height: 88, margin: 0, borderRadius: 10, maxWidth: '40vw' }}/>
                          </TouchableOpacity>
                      ))}
                  </View>
                </View>
              </View>

              <View style={[styles.container, this.state.activeTab === 0 ? styles.hide : null ]}>
                <View style={{
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  alignContent: 'center',
                  justifyContent: 'center',
                  flexGrow: 0,
                  paddingTop: 20
                }}>
                    <TextZ h1 style={[styles.title, styles.h1]}>สูตรบาคาร่า</TextZ>
                </View> 
                <View style={{
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  maxWidth: '100vw',
                }}>
                    <TouchableOpacity onPress={() => vip ? this.onClick('baccarat', '-') : this.openPopup(true)} style={styles.game_block}>
                        <Image source={{ uri: manual_banner }}  style={{ backgroundColor: '#000000', width: 193, height: 88, margin: 0, borderRadius: 10, maxWidth: '40vw' }}/>
                        <TextZ h4 style={styles.title}>กรอกเอง ใช้ได้ทุกค่าย</TextZ>
                    </TouchableOpacity>
                    
                    <TouchableOpacity onPress={() => vip ? this.onClick('baccarat', 'sa') : this.openPopup(true) } style={styles.game_block}>
                        <Image source={{ uri: vip ? sa_banner : sa_disabled }}  style={{ backgroundColor: '#000000', width: 193, height: 88, margin: 0, borderRadius: 10, maxWidth: '40vw' }}/>
                        <TextZ h4 style={styles.title}>ออโต้ SA</TextZ>
                    </TouchableOpacity>
                    {/*<TouchableOpacity onPress={() => vip ? this.onClick('baccarat', 'sexy') : this.openPopup(true)}>
                        <Image source={{ uri: vip ? sexy_banner : sexy_disabled }} style={{width: 193, height: 88, margin: 20, marginBottom: 0, borderRadius: 10, border: '1px solid gold' }}/>
                        <TextZ h4 style={styles.title}>Auto</TextZ>
                    </TouchableOpacity>*/}
                </View>
              </View>
            </View>
          </View>

          <Overlayer
              key='overlay'
              isVisible={this.state.popup}
              windowBackgroundColor="rgba(0, 0, 0, .5)"
              onBackdropPress={() => {}}
              overlayBackgroundColor="#ffffff"
              // overlayStyle={{backgroundColor: '#ffffff', borderRadius: 10}}
          >
              <Settings close={() => this.openPopup(false)} />
          </Overlayer>
        </Page>
    }
}

const styles = StyleSheet.create({
    title: {
      fontWeight: 'bold',
      color: '#FFFFFF',
      textAlign: 'center'
    },
    h1: {
      fontSize: 24,
    },
    game_block: {
        alignContent: 'center',
        alignItems: 'center',
        minWidth: 100, 
        padding: 5,
    },
    page: {
        flex: 1,
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
    },
    container: {
      maxWidth: 920,
    },
    tab: {
      backgroundColor: "rgba(0,0,0,0.8)",
      minWidth: 160,
      maxWidth: 512,
      width: '40vw',
    },
    hide: {
      display: 'none',
    },
    tabContent: {
      backgroundColor: "rgba(0,0,0,0.8)",
      minWidth: 320,
      maxWidth: 1024,
      width: '80vw',
      minHeight: '80vh',
    },
    
});

